var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import "../styles/SliderButtonContainer.css";
var SliderButtonContainer = /** @class */ (function (_super) {
    __extends(SliderButtonContainer, _super);
    function SliderButtonContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderLeftButtonInner = function () {
            var leftDirectionButtonElement = _this.props.leftDirectionButtonElement;
            if (!leftDirectionButtonElement) {
                return React.createElement(FaAngleLeft, { className: "Slider-Button-Icon", size: "32px" });
            }
            return leftDirectionButtonElement;
        };
        _this.renderRightButtonInner = function () {
            var rightDirectionButtonElement = _this.props.rightDirectionButtonElement;
            if (!rightDirectionButtonElement) {
                return React.createElement(FaAngleRight, { className: "Slider-Button-Icon", size: "32px" });
            }
            return rightDirectionButtonElement;
        };
        return _this;
    }
    SliderButtonContainer.prototype.render = function () {
        var _a = this.props, leftButtonOnPress = _a.leftButtonOnPress, rightButtonOnPress = _a.rightButtonOnPress, directionButtonStyle = _a.directionButtonStyle;
        var defaultStyle = directionButtonStyle ? "" : "Slider-Button";
        return (React.createElement("div", { className: "Slider-Buttons-Container" },
            React.createElement("div", { className: "Slider-Button-Container" },
                React.createElement("button", { onClick: leftButtonOnPress, className: defaultStyle + " Slider-Button-Left", style: directionButtonStyle }, this.renderLeftButtonInner())),
            React.createElement("div", { className: "Slider-Button-Container" },
                React.createElement("button", { onClick: rightButtonOnPress, className: defaultStyle + " Slider-Button-Right", style: directionButtonStyle }, this.renderRightButtonInner()))));
    };
    return SliderButtonContainer;
}(React.PureComponent));
export default SliderButtonContainer;
//# sourceMappingURL=SliderButtonContainer.js.map